import React from 'react';
import { Button } from 'primereact/button';

/**
 * Company Impersonation Switch Back Button
 * Shows a fixed button at bottom-left when company admin is impersonating a company user
 * Allows quick switch back to company admin view
 */
const CompanyImpersonationBanner = () => {
    // Only show if impersonating
    const isImpersonating = localStorage.getItem('isCompanyImpersonating') === 'true';

    if (!isImpersonating) {
        return null;
    }

    const handleSwitchBack = () => {
        try {
            console.log('Manually switching back to company admin...');

            // Restore company admin context
            const originalToken = localStorage.getItem('originalCompanyAdminToken');
            const originalUser = localStorage.getItem('originalCompanyAdminUser');

            if (originalToken && originalUser) {
                localStorage.setItem('authToken', originalToken);
                localStorage.setItem('user', originalUser);
                localStorage.setItem('isAuthenticated', 'true');

                // Clear company impersonation data
                localStorage.removeItem('isCompanyImpersonating');
                localStorage.removeItem('originalCompanyAdminToken');
                localStorage.removeItem('originalCompanyAdminUser');
                localStorage.removeItem('originalCompanyAdminAuth');
                localStorage.removeItem('companyImpersonatedUserId');
                localStorage.removeItem('companyImpersonatedUserName');
                localStorage.removeItem('originalCompanyAdminInfo');

                // Redirect to company users page
                window.location.href = '/app/company/users';
            } else {
                console.error('Could not find original company admin data');
                alert('Error: Could not restore company admin session');
            }
        } catch (error) {
            console.error('Switch back failed:', error);
            alert('Error switching back to company admin');
        }
    };

    return (
        <Button
            label="Switch Back to Company Admin"
            icon="pi pi-arrow-left"
            onClick={handleSwitchBack}
            className="p-button-warning"
            style={{
                position: 'fixed',
                bottom: '20px',
                left: '20px',
                zIndex: 10001,
                boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
            }}
        />
    );
};

export default CompanyImpersonationBanner;
